import React, { useState, useEffect } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
//import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";
import validations from "../../../../../../helpers/validations";

const EditVariant = () => {
  const [formData, setFormData] = useState({});
  const [productOptions, setProductOptions] = useState([]);
  const [subproductOptions, setSubproductOptions] = useState([]);
  const [makeOptions, setMakeOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [fuelOptions, setFuelOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [seatingCapacityOptions, setSeatingCapacityOptions] = useState([]);
  const [noOfWheelsOptions, setNoOfWheelsOptions] = useState([]);
  const [warrantyOptions, setWarrantyOptions] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [applysubsidy, setApplysubsidy] = useState(false);
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const [batteryOptions, setBatteryOptions] = useState([]);
  const [hsncodeOptions, setHsnCodeOptions] = useState([]);
  const [stateDdl, setStateDdl] = useState([]);

  const [motorWarranty, setMotorWarranty] = useState([]);
  const [converterWarranty, setConverterWarranty] = useState([]);
  const [controllerWarranty, setControllerWarranty] = useState([]);

  const [taxsetDropdown, setTaxSet] = useState([]);

  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const businessPartnerId = 1; // Use the actual business_partner_id
  const location = useLocation();
  const { data } = location.state || {};

  useEffect(() => {
    fetchMotorWarrantyOptions();
    fetchControllerWarrantyOptions();
    fetchConverterWarrantyOptions();
  }, []);

  const fetchMotorWarrantyOptions = async () => {
    try {
      const payload = {};
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
        payload.itemtype_id = 8;
      } else {
        payload.business_partner_id = businessPartnerId;
        payload.itemtype_id = 8;
      }

      const response = await axiosInstance.post("/item/itemDDL", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((warranty) => ({
        label: warranty.NAME,
        value: warranty.ID,
      }));

      setMotorWarranty(options);
    } catch (error) {
      console.error("Error fetching warranty options:", error);
    }
  };

  const fetchControllerWarrantyOptions = async () => {
    try {
      const payload = {};
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
        payload.itemtype_id = 10;
      } else {
        payload.business_partner_id = businessPartnerId;
        payload.itemtype_id = 10;
      }

      const response = await axiosInstance.post("/item/itemDDL", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((warranty) => ({
        label: warranty.NAME,
        value: warranty.ID,
      }));

      setControllerWarranty(options);
    } catch (error) {
      console.error("Error fetching warranty options:", error);
    }
  };

  const fetchConverterWarrantyOptions = async () => {
    try {
      const payload = {};
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
        payload.itemtype_id = 9;
      } else {
        payload.business_partner_id = businessPartnerId;
        payload.itemtype_id = 9;
      }

      const response = await axiosInstance.post("/item/itemDDL", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((warranty) => ({
        label: warranty.NAME,
        value: warranty.ID,
      }));

      setConverterWarranty(options);
    } catch (error) {
      console.error("Error fetching warranty options:", error);
    }
  };

  useEffect(() => {
    userTypedropdown();
    fetchTaxSetDropdown();
    fetchHsnOptions();
  }, []);

  useEffect(() => {
    stateDropdown();
  }, []);

  const stateDropdown = async () => {
    try {
      const response = await axiosInstance.get("/pincodestatecity/stateList", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));

      setStateDdl(data);
    } catch (error) {
      console.log(error);
    }
  };

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProductOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/product/ddlproduct",
        {
          business_partner_id: formData?.business_partner_id,
          orderBy: "product_id desc",
          page: 0,
          pageSize: 100,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setProductOptions(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  const fetchSubproductOptions = async (productId) => {
    try {
      const response = await axiosInstance.post(
        "/subproduct/ddlsubproduct",
        {
          business_partner_id: businessPartnerId,
          orderBy: "subproduct_id desc",
          page: 0,
          pageSize: 100,
          product_id: productId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((subproduct) => ({
        label: subproduct.NAME,
        value: subproduct.ID,
      }));

      setSubproductOptions(options);
    } catch (error) {
      console.error("Error fetching subproduct options:", error);
    }
  };

  const fetchMakeOptions = async (subproductId) => {
    try {
      const response = await axiosInstance.post(
        "/make/ddlmake",
        {
          business_partner_id: businessPartnerId,
          orderBy: "make_id desc",
          page: 0,
          pageSize: 100,
          subproduct_id: subproductId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((make) => ({
        label: make.NAME,
        value: make.ID,
      }));

      setMakeOptions(options);
    } catch (error) {
      console.error("Error fetching make options:", error);
    }
  };

  const fetchModelOptions = async (makeId) => {
    try {
      const response = await axiosInstance.post(
        "/model/ddlmodel",
        {
          business_partner_id: businessPartnerId,
          orderBy: "model_id desc",
          page: 0,
          pageSize: 100,
          make_id: makeId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  const fetchFuelOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/fueltype/ddlfueltype",
        {
          business_partner_id: formData?.business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((fuel) => ({
        label: fuel.NAME,
        value: fuel.ID,
      }));
      setFuelOptions(options);
    } catch (error) {
      console.error("Error fetching fuel options:", error);
    }
  };

  const fetchColorOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/color/ddlcolor",
        {
          business_partner_id: formData?.business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error("Error fetching color options:", error);
    }
  };

  const fetchSeatingCapacityOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/seatcapacity/ddlseatcapacity",
        {
          business_partner_id: formData?.business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      console.log("response", response);
      const options = response.data.data.data?.map((seating) => ({
        label: seating.NAME,
        value: seating.ID,
      }));

      setSeatingCapacityOptions(options);
      console.log("options", options);
    } catch (error) {
      console.error("Error fetching seating capacity options:", error);
    }
  };

  const fetchNoOfWheelsOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/wheel/ddlwheel",
        {
          business_partner_id: formData?.business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((wheels) => ({
        label: wheels.NAME,
        value: wheels.ID,
      }));

      setNoOfWheelsOptions(options);
    } catch (error) {
      console.error("Error fetching no of wheels options:", error);
    }
  };

  const fetchBatteryOptions = async (mId) => {
    try {
      const response = await axiosInstance.get("/battery/battery-ddl", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((battery) => ({
        label: battery.NAME,
        value: battery.ID,
      }));

      setBatteryOptions(options);
    } catch (error) {
      console.error("Error fetching model options:", error);
    }
  };

  const fetchWarrantyOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/warranty/ddlwarranty",
        {
          business_partner_id: formData?.business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((warranty) => ({
        label: warranty.NAME,
        value: warranty.ID,
      }));

      setWarrantyOptions(options);
    } catch (error) {
      console.error("Error fetching warranty options:", error);
    }
  };

  useEffect(() => {
    const modelId = formData.model;
    const colorId = formData.vehiclecolor;
    const batteryId = formData.variantName;

    if (modelId && colorId && batteryId) {
      fetchVariantName(modelId, colorId, batteryId);
    }
  }, [formData.model, formData.vehiclecolor, formData.variantName]);

  const fetchVariantName = async (modelId, colorId, variantName) => {
    try {
      const payload = {
        model_id: modelId,
        color_id: colorId,
        variant_name: variantName,
      };

      const response = await axiosInstance.post(
        "/variant/generatename",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      const fullVariantName = response?.data?.data;
      console.log(fullVariantName, "fullVariantName");
      // description

      setFormData((prev) => ({
        ...prev,
        description: fullVariantName,
      }));
    } catch (error) {
      console.error("Error fetching subproduct options:", error);
    }
  };

  useEffect(() => {
    fetchProductOptions();
    fetchFuelOptions();
    fetchColorOptions();
    fetchSeatingCapacityOptions();
    fetchNoOfWheelsOptions();
    fetchWarrantyOptions();
  }, [formData?.business_partner_id]);

  useEffect(() => {
    fetchVariantProduct();
    fetchBatteryOptions();
  }, []);

  useEffect(() => {
    if (formData.productName && formData.productName) {
      fetchSubproductOptions(formData.productName);
      // setSubproductOptions([]);
      // setMakeOptions([]);
      // setModelOptions([]);
    }
  }, [formData.productName]);

  useEffect(() => {
    console.log("subproductformData", formData);
    if (formData.subproductName) {
      fetchMakeOptions(formData.subproductName);
      // setMakeOptions([]);
      // setModelOptions([]);
    }
  }, [formData.subproductName]);

  useEffect(() => {
    if (formData.makeName) {
      fetchModelOptions(formData.makeName);
      // setModelOptions([]);
    }
  }, [formData.makeName]);

  useEffect(() => {
    setFormData({ ...formData, subsidyprice: "" });
    setApplysubsidy(false);
    if (
      formData.subproductName &&
      formData.fuel &&
      formData.exshowroomprice &&
      formData.cubic_capacity
    ) {
      let SubproductNAME = subproductOptions.find(
        (item) => item.value == formData.subproductName,
      );
      let FuleNAME = fuelOptions.find((item) => item.value == formData.fuel);
      if (
        SubproductNAME?.label?.replace(/\s+/g, "").toLowerCase() ===
          "electric" &&
        FuleNAME?.label?.replace(/\s+/g, "").toLowerCase() ===
          "electrichighspeed"
      ) {
        setApplysubsidy(true);
        let discountamt = formData.exshowroomprice * 0.4;
        let kwdiscount = formData.cubic_capacity * 15000;
        console.log(
          2,
          discountamt,
          kwdiscount,
          "formDatavariantexshowroomprice",
        );
        if (kwdiscount > discountamt) {
          setFormData({ ...formData, subsidyprice: discountamt });
        } else {
          setFormData({ ...formData, subsidyprice: kwdiscount });
        }
      } else {
        setApplysubsidy(false);
      }
    }
  }, [
    formData.exshowroomprice,
    formData.fuel,
    formData.subproductName,
    formData.cubic_capacity,
    subproductOptions,
  ]);

  useEffect(() => {
    console.log(formData.is_finance_available, "finn");
  }, [formData.is_finance_available]);

  // useEffect(() => {
  //   if (data) {
  //   console.log("variantdata>>>>",data);
  //     setFormData({
  //       productName: { label: data.product_name, value: data.product_id },
  //       subproductName: { label: data.subproduct_name, value: data.subproduct_id },
  //       make: { label: data.make_name, value: data.make_id },
  //       model: { label: data.model_name, value: data.model_id },
  //       fuel: { label: data.fuel_name, value: data.fuel_type_id },
  //       cubic_capacity: data.cubic_capacity,
  //       variantName: data.variant_name,
  //       variantCode: data.variant_code,
  //       vehiclecolor: { label: data.color_name, value: data.color_id },
  //       exshowroomprice: data.exshowroom_price,
  //       seatingcapacity: { label: data.capacity_name, value: data.capacity_id },
  //       noofwheels: { label: data.wheel_name, value: data.wheel_id },
  //       rtoregiamountindi: data.rto_regi_amt_indv,
  //       rtoregiamountcorp: data.rto_regi_amt_cor,
  //       description: data.variant_desc,
  //       hsncode: data.hsncode_id,
  //       warranty: { label: data.warranty_name, value: data.warranty_id },
  //       status: { label: data.status ? "Active" : "Inactive", value: data.status ? "Active" : "Inactive" },
  //     });
  //   }
  // }, [data]);

  const fetchVariantProduct = async () => {
    try {
      const response = await axiosInstance.get(
        `/variant/edit/${data.variant_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response.data.data;
      console.log("fetchedData", fetchedData);

      // Update formData with fetched data
      setFormData({
        makeName: fetchedData?.variantDetails?.make_id,
        model: fetchedData?.variantDetails?.model_id,
        variantName: fetchedData?.variantDetails?.variant_name,
        productName: fetchedData?.variantDetails?.product_id,
        subproductName: fetchedData?.variantDetails?.subproduct_id,
        state_id: fetchedData?.variantDetails?.state_id,
        fuel: fetchedData?.variantDetails?.fuel_type_id,
        cubic_capacity: fetchedData?.variantDetails?.cubic_capacity,
        seatingcapacity: fetchedData?.variantDetails?.capacity_id,
        vehiclecolor: fetchedData?.variantDetails?.color_id,
        // variantName: fetchedData?.variantDetails?.variant_name,
        noofwheels: fetchedData?.variantDetails?.wheel_id,
        // warranty_id:fetchedData?.variantDetails?.warranty_id,
        battery_warranty_id: fetchedData?.variantDetails?.battery_warranty_id,
        motor_warranty_id: fetchedData?.variantDetails?.motor_warranty_id,
        converter_warranty_id:
          fetchedData?.variantDetails?.converter_warranty_id,
        controller_warranty_id:
          fetchedData?.variantDetails?.controller_warranty_id,
        charger_warranty_id: fetchedData?.variantDetails?.charger_warranty_id,
        wiring_kit_id: fetchedData?.variantDetails?.wiring_kit_id,
        shock_absorber_id: fetchedData?.variantDetails?.shock_absorber_id,
        ignition_key_id: fetchedData?.variantDetails?.ignition_key_id,
        lights_warranty_id: fetchedData?.variantDetails?.lights_warranty_id,
        horn_warranty_id: fetchedData?.variantDetails?.horn_warranty_id,
        throttle_warranty_id: fetchedData?.variantDetails?.throttle_warranty_id,
        mcb_warranty_id: fetchedData?.variantDetails?.mcb_warranty_id,

        exshowroomprice: fetchedData?.variantDetails?.exshowroom_price,
        dealer_price: fetchedData?.variantDetails?.dealer_price,
        is_finance_available:
          fetchedData?.variantDetails?.is_finance_available === 1
            ? true
            : false,
        hsncode: fetchedData?.variantDetails?.hsncode_id,
        variantCode: fetchedData?.variantDetails?.variant_code,
        description: fetchedData?.variantDetails?.variant_desc,
        subsidyprice: fetchedData?.variantDetails?.subsidyprice,
        productimage1: fetchedData?.variantDetailsimage[0]?.imageURL,
        productimage2: fetchedData?.variantDetailsimage[1]?.imageURL,
        productimage3: fetchedData?.variantDetailsimage[2]?.imageURL,
        productimage4: fetchedData?.variantDetailsimage[3]?.imageURL,
        productimage5: fetchedData?.variantDetailsimage[4]?.imageURL,
        productimage1id:
          fetchedData?.variantDetailsimage[0]?.variant_document_id,
        productimage2id:
          fetchedData?.variantDetailsimage[1]?.variant_document_id,
        productimage3id:
          fetchedData?.variantDetailsimage[2]?.variant_document_id,
        productimage4id:
          fetchedData?.variantDetailsimage[3]?.variant_document_id,
        productimage5id:
          fetchedData?.variantDetailsimage[4]?.variant_document_id,
        // modelDesc: fetchedData.model_desc,
        taxid: fetchedData?.variantDetails?.tax_id,
        status: fetchedData.variantDetails?.status === 1 ? true : false,
      });
      if (fetchedData?.subsidyprice) {
        setApplysubsidy(true);
      } else {
        setApplysubsidy(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  console.log("variantformData", formData);

  const fetchTaxSetDropdown = async () => {
    try {
      const response = await axiosInstance.post(
        "/tax/ddltax",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data;
      console.log(formattedData, "VARIANTDATA");

      const variantData = formattedData.map((data) => ({
        value: data.ID,
        label: data.NAME,
        tax_percent: data?.tax_percent,
      }));

      setTaxSet(variantData);
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
  };

  const handleFormSubmit = async (formData) => {
    console.log("variantFormData", formData);
    const errors = {};
    let isValid = true;
    const businessPartnerId = localStorage.getItem("business_partner_id");

    // Validation loop
    VariantInputs.forEach((field) => {
      if (field.validation) {
        if (field.name === "status" && formData.status === 0) {
          // Allow status = 0
        } else if (field.validation.required && !formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (
      formData.dealer_price &&
      formData.exshowroomprice &&
      Number(formData.dealer_price) > Number(formData.exshowroomprice)
    ) {
      errors.dealer_price =
        "Dealer Price cannot be greater than Ex-Showroom Price";
      isValid = false;
    }

    // Set validation errors and exit if form is invalid
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    console.log("formdatavariant", formData);

    // Confirmation dialog before making API call
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to create this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          let hasImage = false;

          const newformData = new FormData();
          const variant_document_id = [];

          // Append files and their IDs
          if (
            formData?.productimage1 &&
            formData.productimage1 instanceof File
          ) {
            newformData.append("variant_image", formData.productimage1);
            variant_document_id.push(formData?.productimage1id);
            console.log("Appended image 1:", formData.productimage1);
          } else {
            console.log("No valid image 1 to append");
          }

          if (
            formData?.productimage2 &&
            formData.productimage2 instanceof File
          ) {
            newformData.append("variant_image", formData.productimage2);
            variant_document_id.push(formData?.productimage2id);
            console.log("Appended image 2:", formData.productimage2);
          } else {
            console.log("No valid image 2 to append");
          }

          if (
            formData?.productimage3 &&
            formData.productimage3 instanceof File
          ) {
            newformData.append("variant_image", formData.productimage3);
            variant_document_id.push(formData?.productimage3id);
            console.log("Appended image 2:", formData.productimage2);
          } else {
            console.log("No valid image 2 to append");
          }

          if (
            formData?.productimage4 &&
            formData.productimage4 instanceof File
          ) {
            newformData.append("variant_image", formData.productimage4);
            variant_document_id.push(formData?.productimage4id);
            console.log("Appended image 2:", formData.productimage2);
          } else {
            console.log("No valid image 2 to append");
          }
          if (
            formData?.productimage5 &&
            formData.productimage5 instanceof File
          ) {
            newformData.append("variant_image", formData.productimage5);
            variant_document_id.push(formData?.productimage5id);
            console.log("Appended image 2:", formData.productimage2);
          } else {
            console.log("No valid image 2 to append");
          }
          // Append other form data fields
          newformData.append("product_id", formData.productName);
          newformData.append("state_id", formData.state_id);
          newformData.append("subproduct_id", formData.subproductName);
          newformData.append("make_id", formData.makeName);
          newformData.append("model_id", formData.model);
          newformData.append("fuel_type_id", formData.fuel);
          newformData.append("cubic_capacity", formData.cubic_capacity || 0);
          newformData.append("variant_name", formData.variantName);
          newformData.append("color_id", formData.vehiclecolor);
          // newformData.append("exshowroom_price", formData.exshowroomprice);
          // newformData.append("dealer_price", formData.dealer_price);

          newformData.append("dealer_price", formData.dealer_price);

          newformData.append(
            "is_finance_available",
            formData.is_finance_available === true ? 1 : 0,
          );

          newformData.append("exshowroom_price", formData.exshowroomprice);

          newformData.append("variant_desc", formData.description);
          // newformData.append("warranty_id", formData.warranty_id || 0);
          // newformData.append("battery_warranty_id", formData.battery_warranty_id || 0);
          newformData.append(
            "motor_warranty_id",
            formData.motor_warranty_id || 0,
          );
          newformData.append(
            "converter_warranty_id",
            formData.converter_warranty_id || 0,
          );
          newformData.append(
            "controller_warranty_id",
            formData.controller_warranty_id || 0,
          );
          newformData.append(
            "charger_warranty_id",
            formData.charger_warranty_id || 0,
          );

          newformData.append("mcb_warranty_id", formData.mcb_warranty_id || 0);
          newformData.append(
            "throttle_warranty_id",
            formData.throttle_warranty_id || 0,
          );
          newformData.append(
            "horn_warranty_id",
            formData.horn_warranty_id || 0,
          );
          newformData.append(
            "lights_warranty_id",
            formData.lights_warranty_id || 0,
          );
          newformData.append("ignition_key_id", formData.ignition_key_id || 0);
          newformData.append(
            "shock_absorber_id",
            formData.shock_absorber_id || 0,
          );
          newformData.append("wiring_kit_id", formData.wiring_kit_id || 0);

          formData?.subsidyprice &&
            newformData.append("subsidyprice", formData.subsidyprice);
          newformData.append("tax_id", formData.taxid);
          newformData.append("status", formData.status === true ? 1 : 0);

          // Append the variant_document_id array to FormData
          if (variant_document_id.length > 0) {
            newformData.append(
              "variant_document_id",
              JSON.stringify(variant_document_id),
            ); // Store it as a JSON string
          }

          // Log FormData contents
          for (let [key, value] of newformData.entries()) {
            console.log(`FormData entry: ${key}:`, value);
          }

          // API request to update the variant (without setting 'Content-Type')
          const response = await axiosInstance.patch(
            `/variant/update/${data.variant_id}`,
            newformData,
            {
              headers: {
                Authorization: `Bearer ${authToken}`, // Only add the Authorization header
              },
            },
          );

          // showCustomAlert({
          //   title: "Success",
          //   text: "Variant updated successfully.",
          //   icon: "success",
          //   confirmButtonText: "OK",
          //   callback: () => {
          //     navigate('/admin/manage-product/variant'); // Redirect on success
          //   },
          // });

          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Variant updated successfully.",
              icon: "success",
              confirmButtonText: "OK",
            }).then(() => {
              navigate("/admin/manage-product/variant"); // Redirect on success
            });
          }
        } catch (error) {
          console.error("Error submitting form:", error?.response?.data?.data);

          const errorMessage =
            error?.response?.data?.data ||
            "Failed to update variant. Please try again.";
          showErrorAlert({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
    });
    if (!result.isConfirmed) {
      // setLoading(false);
    }
  };

  // const handleFormSubmit = async (formData) => {
  //   console.log("variantFormData", formData);
  //   const errors = {};
  //   let isValid = true;
  //   const businessPartnerId = localStorage.getItem("business_partner_id");
  //   VariantInputs.forEach((field) => {
  //     if (field.validation) {
  //       if (field.name === "status" && formData.status === 0) {
  //         // Allow status = 0
  //       } else if (field.validation.required && !formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       } else if (
  //         field.validation.pattern &&
  //         !field.validation.pattern.test(formData[field.name])
  //       ) {
  //         errors[field.name] = field.validation.message;
  //         isValid = false;
  //       }
  //     }
  //   });

  //   // Set validation errors and exit if form is invalid
  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }

  // console.log("formdatavariant",formData);

  //   try {
  //     const newformData = new FormData();
  //     const variant_document_id=[]
  //     if (formData?.productimage1 && formData.productimage1 instanceof File) {
  //       newformData.append('variant_image', formData.productimage1);
  //       console.log("Appended image:", formData.productimage1);
  //     } else {
  //       console.log("No valid image to append");
  //     }
  //     newformData.append("product_id", formData.productName);
  //     newformData.append("subproduct_id", formData.subproductName);
  //     newformData.append("make_id", formData.makeName);
  //     newformData.append("model_id", formData.modelName);
  //     newformData.append("fuel_type_id", formData.fuel);
  //     newformData.append("cubic_capacity", formData.cubic_capacity);
  //     newformData.append("variant_name", formData.variantName);
  //     newformData.append("color_id", formData.vehiclecolor);
  //     newformData.append("exshowroom_price", formData.exshowroomprice);
  //     newformData.append("variant_desc", formData.description);
  //     newformData.append("warranty_id", formData.warranty_id);
  //     formData?.subsidyprice && newformData.append("subsidyprice",formData.subsidyprice );
  //     newformData.append("tax_id", formData.taxid);
  //     newformData.append("status", formData.status === true ? 1 : 0);
  //   // Check if the product image exists and is a valid File

  // // Log the FormData contents
  // for (let [key, value] of newformData.entries()) {
  //   console.log(`hi${key}:`, value);
  // }
  //     console.log("newformData",newformData);

  //     // const payload = {
  //     //   product_id: formData.productName,
  //     //     subproduct_id: formData.subproductName,
  //     //     make_id: formData.makeName,
  //     //     model_id: formData.modelName,
  //     //     fuel_type_id: formData.fuel,
  //     //     cubic_capacity: formData.cubic_capacity,
  //     //     variant_name: formData.variantName,
  //     //     variant_code: formData.variantCode,
  //     //     color_id: formData.vehiclecolor,
  //     //     exshowroom_price: formData.exshowroomprice,
  //     //     variant_desc: formData.description,
  //     //     warranty_id: formData.warranty_id,
  //     //     subsidyprice:applysubsidy?String(formData.subsidyprice):null,
  //     //     tax_id:formData.taxid,
  //     //     status: formData.status === true ? 1 : 0,
  //     // };

  //     // Show confirmation dialog before making the API call
  //     showCustomAlert({
  //       title: "Confirmation",
  //       text: "Are you sure you want to update this record in Variant?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: "Yes",
  //       cancelButtonText: "Cancel",
  //       callback: async () => {
  //         try {
  //           // API request to update the variant
  //           const response = await axiosInstance.patch(
  //             `/variant/update/${data.variant_id}`,
  //             newformData,
  //             {
  //               headers: {
  //                 "Content-Type": "application/json",
  //                 Authorization: `Bearer ${authToken}`,
  //               },
  //             }
  //           );
  //           showCustomAlert({
  //             title: "Success",
  //             text: "Variant updated successfully.",
  //             icon: "success",
  //             confirmButtonText: "OK",
  //             callback: () => {
  //               navigate('/admin/manage-product/variant');
  //             },
  //           });
  //         } catch (error) {
  //           console.error("Error submitting form:", error);

  //           const errorMessage = error.response?.data?.message || "Failed to update variant. Please try again.";
  //           showErrorAlert({
  //             title: "Error",
  //             text: errorMessage,
  //             icon: "error",
  //             confirmButtonText: "OK",
  //           });
  //         }
  //       },
  //     });
  //   } catch (error) {
  //     console.error("Error during form submission:", error);
  //   }
  // };
  const fetchHsnOptions = async () => {
    try {
      const payload = {};
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/hsncode/ddlhsncode",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((warranty) => ({
        label: warranty.NAME,
        value: warranty.ID,
      }));

      setHsnCodeOptions(options);
    } catch (error) {
      console.error("Error fetching warranty options:", error);
    }
  };
  const VariantInputs = [
    {
      name: "productName",
      label: "Product",
      type: "dropdown",
      options: productOptions,
      required: true,
      validation: {
        required: true,
      },
      gridClass: "col-lg-4",
    },
    {
      name: "model",
      label: "Model",
      type: "dropdown",
      options: modelOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "variantName",
      label: "Battery",
      placeholder: "Enter Variant Name",
      type: "dropdown",
      options: batteryOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },

    {
      name: "vehiclecolor",
      label: "Color",
      type: "dropdown",
      options: colorOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },

    {
      name: "state_id",
      label: "State",
      type: "dropdown",
      options: stateDdl,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "dealer_price",
      label: "Dealer Price",
      placeholder: "Price",
      type: "number",
      isDecimal: true,
      validation: validations.price({ required: true, minLength: 1 }),
      // validation: {
      //     minLength: 4,
      //   maxLength: 6,
      //   pattern: /^\d+(\.\d{1,2})?$/, // Allows up to 2 decimal places
      //   message: "Only digits and up to 2 decimal places are allowed",
      //   required: true,

      // },
      // validation: {
      //   required: true,

      //   minLength: 4,
      //   maxLength: 6,

      //   // Enforces total length 4–6 + digits with optional decimal (up to 2 places)
      //   pattern: /^(?=.{4,6}$)\d+(\.\d{1,2})?$/,

      //   message:
      //     "Dealer Price must be 4–6 characters long and contain only digits with up to 2 decimal places",
      // },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "exshowroomprice",
      label: "Recommended Selling Price",
      placeholder: "Recommended Selling Price",
      type: "number",
      isDecimal: true,
      validation: validations.price({ required: true, minLength: 1 }),
      // validation: {
      //   required: true,

      //   minLength: 4,
      //   maxLength: 6,

      //   // Enforces total length 4–10 + digits with optional decimal (up to 2 places)
      //   pattern: /^(?=.{4,6}$)\d+(\.\d{1,2})?$/,

      //   message:
      //     "Recommended Selling Price must be 4–6 digits long and contain only digits with up to 2 decimal places",
      // },
      required: true,
      gridClass: "col-lg-4",
    },
    ...(applysubsidy
      ? [
          {
            name: "subsidyprice",
            label: "subsidy price",
            placeholder: "subsidy price",
            type: "number",
            isDecimal: true,
            validation: validations.price({ required: true, minLength: 1 }),
            disabled: true,
            // validation: {
            //   required: true,
            // },
            required: true,
            gridClass: "col-lg-4",
          },
        ]
      : []),

    {
      name: "taxid",
      label: "Tax",
      type: "dropdown",
      options: taxsetDropdown,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "description",
      label: "Variant Name",
      placeholder: "Enter Variant Name",
      type: "text",
      disabled: true,
      validation: validations.variant({ required: true }),
      // validation: {
      //   required: true,

      //   minLength: 5,
      //   maxLength: 70,

      //   // Enforces no spaces + length 5–100
      //   // pattern: /^[A-Za-z ]{5,80}$/,
      //   // pattern: /^[A-Za-z0-9 !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{5,70}$/,

      //   // message:
      //   //   "Variant Name must be 5-70 characters long and can contain spaces",
      // },
      // required: true,
      // disabled: true,
      gridClass: "col-lg-4",
    },
    {
      name: "charger_warranty_id",
      label: "Charger Warranty",
      type: "dropdown",
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "converter_warranty_id",
      label: "Converter ",
      type: "dropdown",
      options: converterWarranty,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "motor_warranty_id",
      label: "Motor ",
      type: "dropdown",
      options: motorWarranty,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "controller_warranty_id",
      label: "Controller ",
      type: "dropdown",
      options: controllerWarranty,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "mcb_warranty_id",
      label: "MCB Warranty",
      type: "dropdown",
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "throttle_warranty_id",
      label: "Throttle Warranty",
      type: "dropdown",
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "horn_warranty_id",
      label: "Horn Warranty",
      type: "dropdown",
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "lights_warranty_id",
      label: "Lights Warranty",
      type: "dropdown",
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "ignition_key_id",
      label: "Ignition Warranty",
      type: "dropdown",
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "shock_absorber_id",
      label: "Shock Absorber Warranty",
      type: "dropdown",
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "wiring_kit_id",
      label: "Wiring Kit Warranty",
      type: "dropdown",
      options: warrantyOptions,
      validation: {
        required: true,
      },
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "productimage1",
      label: "Product Image1",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      gridClass: "col-lg-4",
      validation: formData?.productimage1 || formData?.productimage1id ? { required: true } : undefined,
      required: !!(formData?.productimage1 || formData?.productimage1id),
    },
    {
      name: "productimage2",
      label: "Product Image2",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      gridClass: "col-lg-4",
      validation: formData?.productimage2 || formData?.productimage2id ? { required: true } : undefined,
      required: !!(formData?.productimage2 || formData?.productimage2id),
    },
    {
      name: "productimage3",
      label: "Product Image3",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      gridClass: "col-lg-4",
      validation: formData?.productimage3 || formData?.productimage3id ? { required: true } : undefined,
      required: !!(formData?.productimage3 || formData?.productimage3id),
    },
    {
      name: "productimage4",
      label: "Product Image4",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      gridClass: "col-lg-4",
      validation: formData?.productimage4 || formData?.productimage4id ? { required: true } : undefined,
      required: !!(formData?.productimage4 || formData?.productimage4id),
    },
    {
      name: "productimage5",
      label: "Product Image5",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      gridClass: "col-lg-4",
      validation: formData?.productimage5 || formData?.productimage5id ? { required: true } : undefined,
      required: !!(formData?.productimage5 || formData?.productimage5id),
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-1",
    },
    // {
    //   name: "is_finance_available",
    //   label: "Is Finance Option Available",
    //   type: "checkbox",
    //   // required: true,
    //   // validation: { required: true },
    //   getValue: (value) => (value ? 1 : 0),
    //   gridClass: "col-lg-4",
    // },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Edit Variant</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Variant Details
              </span>
              <DynamicForm
                validateOnMount
                formConfig={VariantInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>

            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(VariantInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  VariantInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => {
                  handleFormSubmit(formData);
                }}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditVariant;
